import { render } from "./Create.vue?vue&type=template&id=bd49cbd4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=bd49cbd4&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=bd49cbd4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd49cbd4"]])

export default __exports__